import { REGEX_PATTERNS, VALIDATION_MESSAGES } from '../constants/validation';

/**
 * Returns an email validation error message, or null if valid.
 */
export const getEmailValidationError = (
  value,
  {
    requiredMessage = 'Email is required',
    invalidMessage = VALIDATION_MESSAGES.INVALID_EMAIL,
    extraValidator,
  } = {}
) => {
  if (!value || !String(value).trim()) {
    return requiredMessage;
  }

  if (!REGEX_PATTERNS.EMAIL.test(String(value).trim())) {
    return invalidMessage;
  }

  if (extraValidator) {
    const extraError = extraValidator(value);
    if (extraError) {
      return extraError;
    }
  }

  return null;
};

/**
 * Border / focus classes for real-time email validation feedback.
 */
export const getEmailValidationInputClass = (
  baseClass,
  { touched, error, value, defaultBorderClass = 'border-jet-gray-300 focus:ring-jet-blue' }
) => {
  const hasError = touched && error;
  const isValid = touched && !error && value?.trim();

  if (hasError) {
    return `${baseClass} border-red-500 focus:ring-red-200 focus:border-red-500`;
  }

  if (isValid) {
    return `${baseClass} border-green-500 focus:ring-green-200 focus:border-green-500`;
  }

  return `${baseClass} ${defaultBorderClass}`;
};
